<template>
  <nav class="navbar">
    <div class="navbar-container">
      <img class="navbar-logo" src="../images/logo_nuevo.png" alt="Logo" />
      <span
        v-if="showLogout"
        role="button"
        tabindex="0"
        class="navbar-logout"
        @click="emit('logout')"
        @keydown.enter.prevent="emit('logout')"
        @keydown.space.prevent="emit('logout')"
      >
        Cerrar sesión
      </span>
    </div>
  </nav>
</template>

<script setup>
/* eslint-disable quotes */

defineProps({
  showLogout: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["logout"]);
</script>

<style scoped>
@import "../css/home.css";
</style>
